import React, { useState } from 'react';
import { Icon, TextField } from '@mui/material';

import DialogBase from './DialogBase';
import { Organisatie } from '../../../models/organisatie/organisatie';

interface DialogEditDisplayNameProps {
  open: boolean;
  isZonderGebied: boolean;
  organisatie: Organisatie;
  onClose: () => void;
  onSubmit: (organisatie: Organisatie) => void;
}

const DialogEditDisplayName: React.FC<DialogEditDisplayNameProps> = ({
  open,
  isZonderGebied,
  organisatie,
  onClose,
  onSubmit,
}) => {
  // const [displayName, setDisplayName] = useState(organisatie.displayName);
  const [currentOrganisatie, setCurrentOrganisatie] = useState(organisatie);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Create a copy of the state and update the displayName
    const updatedOrganisatie = {
      ...organisatie, // Copy the current state
      displayName: event.target.value, // Update displayName
    };

    // Update the state to trigger re-render
    setCurrentOrganisatie(updatedOrganisatie);
  };

  const handleSubmit = () => {
    if (currentOrganisatie.id && currentOrganisatie.displayName) {
      onSubmit(currentOrganisatie);
      onClose(); // Close the dialog after submission
    } 
    else {
      console.error('Invalid organisatie data: ID or display name is missing.');
    }
  };

  return (
    <DialogBase
      open={open}
      title="Organisatie wijzigen"
      contentText=""
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmButtonText="Opslaan"
      confirmButtonIcon={<Icon>save</Icon>}
    >
      <section>
        <label>Vul een naam in die wordt gebruikt voor weergave</label>
        <br/>
        <TextField
          required
          fullWidth
          // sx={{ mt: 2 }}
          id="displayName"
          label="Naam" 
          variant="filled"
          value={currentOrganisatie?.displayName ? String(currentOrganisatie.displayName) : ""}
          onChange={handleInputChange}
          // error={!!validationErrors.displayName}
        />

      </section>
      
    </DialogBase>
  );
};

export default DialogEditDisplayName;
